<template>
  <BoxedLayout
    :class="{
      'page-hero md:pt-14 lg:pt-32': !noHero && !startsWithHero && !IS_MOBILE_APP,
      'pb-20': !IS_MOBILE_APP,
      'mt-6': IS_MOBILE_APP && !startsWithHero,
      'mb-6': IS_MOBILE_APP,
    }"
    :slices="slices"
  />
</template>

<script lang="ts" setup>
import type { Slice } from './types'
import BoxedLayout from './boxed-layout.vue'
import type { Features } from '@core/config/features'
import type { GQLPageMeta } from '@core/composables/use-page-meta/generated/page-meta'
import type { GQLSlice } from './generated/slices'
import { isDefinedSlice } from './slices'

const IS_MOBILE_APP = __IS_MOBILE_APP__

const props = defineProps<{
  body: GQLSlice[]
  page: GQLPageMeta
  noHero?: boolean
}>()

const { $features } = useNuxtApp()
const startsWithHero = computed(() => {
  return (
    slices.value[0]?.type === 'HeroSearchFormSlice' ||
    slices.value[0]?.type === 'HeroExchangeRateSlice' ||
    slices.value[0]?.type === 'HeroProviderVsProviderSlice' ||
    slices.value[0]?.type === 'HeroTopupSlice' ||
    (slices.value[0]?.type === 'SpotlightedProviderSlice' &&
      slices.value[0]?.layout === 'free_fluid') ||
    (slices.value[0]?.type === 'LeadCaptureSlice' && slices.value[0]?.layout === 'free_fluid') ||
    (slices.value[0]?.type === 'VerticalAgnosticComparisonSlice' &&
      slices.value[0]?.layout === 'free_fluid') ||
    (slices.value[0]?.type === 'EsimSearchFormSlice' && slices.value[0]?.layout === 'free_fluid')
  )
})

provide('pageContext', props.page)

const slices = computed((): Slice[] => {
  const slices: Slice[] = []
  let nextSliceId: string | undefined
  let removeNextSlice = false
  props.body.forEach((slice) => {
    if (!isDefinedSlice(slice)) {
      return
    }
    if (removeNextSlice) {
      removeNextSlice = false
      return
    }
    if (slice._type === 'AnchorSlice') {
      nextSliceId = slice.id
      return
    }
    if (slice._type === 'ExperimentSlice') {
      const value = $features?.getValue(slice.featureFlagKey as keyof Features)
      if (!value || value === 'off' || value === 'control') {
        removeNextSlice = slice.featureFlagValue !== 'off' && slice.featureFlagValue !== 'control'
      } else {
        removeNextSlice = value !== slice.featureFlagValue
      }
      return
    }
    // merge blocks into a single div
    if (slice._type === 'Block' || slice._type === 'Image') {
      const previous = slices.length ? slices[slices.length - 1] : undefined
      if (!nextSliceId && previous?.type === 'Block' && Array.isArray(previous.content)) {
        previous.content.push(slice)
      } else {
        slices.push({
          layout: 'boxed_66',
          type: slice._type,
          id: nextSliceId,
          content: [slice],
        })
        nextSliceId = undefined
      }
    } else {
      slices.push({
        layout: 'layout' in slice ? slice.layout : 'boxed_66',
        type: slice._type,
        id: nextSliceId,
        content: slice._type === 'BoxBreakSlice' ? null : slice,
      })
      nextSliceId = undefined
    }
  })
  return slices
})
</script>
